import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import * as jwt_decode from "jwt-decode";
import { CommonService } from '../shared/common.service';

@Injectable({
  providedIn: 'root'
})
// export class PermissionGuard implements CanActivate, CanActivateChild {
//   constructor(private router: Router) { }

//   getStorage(key): any {
//     const x = localStorage.getItem(key);
//     try {
//       return JSON.parse(x);
//     } catch (e) {
//       return x;
//     }
//   }

//   canActivate(
//     next: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
//       let hasPermission = false;
//       const routeAccess = next.data.access || false;
//       const routeAccessLevel = next.data.level || 'R';

//       if (!routeAccess) {
//         localStorage.removeItem('activeIndex');
//         this.router.navigate(['/main']);
//         return hasPermission;
//       }

//       const access = this.getStorage("_per");

//       if (access.hasOwnProperty(routeAccess)) {
//         hasPermission = this.evaluatePermissions(routeAccessLevel, access, routeAccess);
//       }

//       if ( ! hasPermission) {
//         localStorage.removeItem('activeIndex');
//         this.router.navigate(['/main']);
//       }

//       return hasPermission;

//   }

//   evaluatePermissions(routeAccessLevel, access, routeAccess) {
//     let hasPermission = false;
//     switch(routeAccessLevel) {
//       case 'R':
//         if (access[routeAccess] !== 'H') {
//           hasPermission = true;
//         }
//         break;
//       case 'W':
//         if (access[routeAccess] === 'W') {
//           hasPermission = true;
//         }
//         break;
//       case 'H':
//       default:
//         hasPermission = false;
//         break;
//     }

//     return hasPermission;
//   }

//   canActivateChild(
//     next: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
//     return this.canActivate(next, state);
//   }

// }

export class PermissionGuard implements CanActivate {
  constructor(private router: Router, private commonService: CommonService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.commonService.isAuthenticated()) {
      let userData = this.commonService.getUser();
      if (route.data.role && route.data.role.indexOf(userData.role) == -1) {
        this.router.navigate(["/main/dashboard"]);
        return false;
      } else {
        return true;
      }
    }
    this.router.navigate(["/auth/login"]);
    return false;
  }
}
